import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=014c8d9b&scoped=true"
import script from "./PaymentButton.vue?vue&type=script&lang=js"
export * from "./PaymentButton.vue?vue&type=script&lang=js"
import style0 from "./PaymentButton.vue?vue&type=style&index=0&id=014c8d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014c8d9b",
  null
  
)

export default component.exports